import React, { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const ChatNameCardIcon: FC<SvgIconProps> = ({ ...iconProps }) => (
  <SvgIcon {...iconProps} viewBox="0 0 48 48">
    <path
      fillRule="evenodd"
      clipRule-rule="evenodd"
      d="M2 12C2 9.79086 3.79086 8 6 8H42C44.2091 8 46 9.79086 46 12V36C46 38.2091 44.2091 40 42 40H6C3.79086 40 2 38.2091 2 36V12ZM17 20C17 21.6569 15.6569 23 14 23C12.3431 23 11 21.6569 11 20C11 18.3431 12.3431 17 14 17C15.6569 17 17 18.3431 17 20ZM8.32874 29.0362C9.14211 26.6869 11.3741 25 14 25C16.6259 25 18.8579 26.6869 19.6713 29.0362C20.0326 30.08 19.1046 31 18 31H10C8.89543 31 7.96737 30.08 8.32874 29.0362ZM23 21.5C23 20.6716 23.6716 20 24.5 20H39.5C40.3284 20 41 20.6716 41 21.5C41 22.3284 40.3284 23 39.5 23H24.5C23.6716 23 23 22.3284 23 21.5ZM24.5 26C23.6716 26 23 26.6716 23 27.5C23 28.3284 23.6716 29 24.5 29H34.5C35.3284 29 36 28.3284 36 27.5C36 26.6716 35.3284 26 34.5 26H24.5Z"
    />
  </SvgIcon>
);
export default ChatNameCardIcon;
